export default "__VITE_ASSET__135bb7da__"